import { z } from 'zod';

export const HelioTotemCode = z.enum([
  'INDEPENDENCY',
  'PLEASURE',
  'CONTROL',
  'SECURITY',
  'PROTECTION',
  'INTEGRITY',
  'ALTRUISM',
  'UNIVERSALISM',
]);

export type HelioTotemCodeT = z.infer<typeof HelioTotemCode>;
